// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-group {
  display: flex;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 100px;
  background-color: rgb(220, 220, 220); /* Brighter background color */
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.button {
  flex: 1 1;
  border: none;
  outline: none;
  color: black;
  padding: 10px;
  font-weight: bold;
}

.button:hover {
  background-color: #f2f2f2;
}

.button.active {
  background-color: #009374;
  color: white;
  border-radius: 20px;
}

/* Updated styles to remove grey color */
.button-group .button:not(.active) {
  background-color: rgb(220, 220, 220); /* Brighter background color */
}

/* Stylish glasses border animation */
.button-group {
  position: relative;
}

.button-group::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: #009374; /* Border color */
  transform: translateY(-50%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.button.active::before {
  opacity: 1;
}

/* Responsive */
@media (max-width: 600px) {
  .button {
    font-size: 1.1rem;
  }
  .button-group {
    margin-top: 90px;
  }
}

@media (min-width: 600px) {
  .button {
    font-size: 1.4rem;
  }
  .button-group {
    margin-top: 120px;
  }
}

@media (min-width: 768px) {
  .button {
    font-size: 1.4rem;
  }
  .button-group {
    margin-top: 95px;
  }
}

@media (min-width: 992px) {
  .button {
    font-size: 1.4rem;
  }
  .button-group {
    margin-top: 90px;
  }
}

@media (min-width: 1200px) {
  .button {
    font-size: 1.4rem;
  }
  .button-group {
    margin-top: 85px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Sub-Components/TopButton.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC,EAAE,8BAA8B;EACpE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,oCAAoC,EAAE,8BAA8B;AACtE;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB,EAAE,iBAAiB;EAC5C,2BAA2B;EAC3B,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".button-group {\n  display: flex;\n  border-radius: 20px;\n  overflow: hidden;\n  margin-top: 100px;\n  background-color: rgb(220, 220, 220); /* Brighter background color */\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.button {\n  flex: 1;\n  border: none;\n  outline: none;\n  color: black;\n  padding: 10px;\n  font-weight: bold;\n}\n\n.button:hover {\n  background-color: #f2f2f2;\n}\n\n.button.active {\n  background-color: #009374;\n  color: white;\n  border-radius: 20px;\n}\n\n/* Updated styles to remove grey color */\n.button-group .button:not(.active) {\n  background-color: rgb(220, 220, 220); /* Brighter background color */\n}\n\n/* Stylish glasses border animation */\n.button-group {\n  position: relative;\n}\n\n.button-group::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background-color: #009374; /* Border color */\n  transform: translateY(-50%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.button.active::before {\n  opacity: 1;\n}\n\n/* Responsive */\n@media (max-width: 600px) {\n  .button {\n    font-size: 1.1rem;\n  }\n  .button-group {\n    margin-top: 90px;\n  }\n}\n\n@media (min-width: 600px) {\n  .button {\n    font-size: 1.4rem;\n  }\n  .button-group {\n    margin-top: 120px;\n  }\n}\n\n@media (min-width: 768px) {\n  .button {\n    font-size: 1.4rem;\n  }\n  .button-group {\n    margin-top: 95px;\n  }\n}\n\n@media (min-width: 992px) {\n  .button {\n    font-size: 1.4rem;\n  }\n  .button-group {\n    margin-top: 90px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .button {\n    font-size: 1.4rem;\n  }\n  .button-group {\n    margin-top: 85px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
